<template>
    <div
        class="row pl-2 pb-2 pt-2 justify-space-between align-center"
        style="border-bottom: 1px solid #e9e9e9"
        v-if="ShowSelection && DanhSachVe.length != 0"
    >
        <DxCheckBox
            v-model="IsChonTatCa"
            text="Chọn tất cả"
            :onValueChanged="onValueChangedChonTatCa"
        />

        <!-- <DxButton
            :disabled="
                (ItemSelected || []).length == 0 ||
                (ItemSelected || []).some((e) => e.DaPhatHanh)
            "
            type="default"
            styling-mode="text"
            icon="mdi mdi-receipt-text-send-outline"
            hint=""
            @click="PhatHanhVe()"
        /> -->
    </div>

    <div class="row justify-center pa-3" v-if="DanhSachVe.length == 0">
        Không có thông báo mới!
    </div>
    <div
        class="frame-danh-sach-ve"
        :style="`overflow: auto; height: ${
            ShowSelection
                ? `calc(100vh - ${DaLayHetVe ? `104px` : `144px`})`
                : `calc(100vh - ${DaLayHetVe ? `80px` : `120px`})`
        }`"
        v-else
    >
        <div
            class="row align-center mt-3"
            v-for="(item, index) in DanhSachVe"
            :key="item"
        >
            <DxCheckBox
                v-if="ShowSelection"
                class="mr-2"
                v-model="item.DaChon"
            />
            <div class="xs12">
                <ItemVeVue :item="item" />
            </div>
        </div>
    </div>
    <div class="row justify-center mt-1 pb-1">
        <DxButton
            v-if="!DaLayHetVe"
            text="Xem thêm"
            type="default"
            styling-mode="contained"
            @click="LayDanhSachVe()"
        />
    </div>
</template>

<script>
import { DxCheckBox, DxButton } from "devextreme-vue";
import ItemVeVue from "./ItemVe.vue";
import moment from "moment";
export default {
    components: {
        DxCheckBox,
        DxButton,
        ItemVeVue,
    },
    data() {
        return {
            DanhSachVe: [],
            DaLayHetVe: false,
            selectedItemKeys: [],
            ShowSelection: true,
            IsChonTatCa: false,
        };
    },
    computed: {
        CauHinhBenXePhatHanhHoaDonDienTu: {
            get() {
                return this.$store.state.HoaDonDienTu
                    .CauHinhBenXePhatHanhHoaDonDienTu;
            },
            set(data) {
                this.$store.commit("HoaDonDienTu/Set", {
                    key: "CauHinhBenXePhatHanhHoaDonDienTu",
                    data,
                });
            },
        },
        LocBaoCao: {
            get() {
                return this.$store.state.BaoCao.LocBaoCao;
            },
            set(data) {
                this.$store.commit("BaoCao/Set", {
                    key: "LocBaoCao",
                    data: data,
                });
            },
        },
        ItemSelected() {
            return this.DanhSachVe.filter((e) => e.DaChon);
        },
    },
    methods: {
        async LayDanhSachVe() {
            try {
                this.$startLoading;
                let take = 10;
                this.DaLayHetVe = false;
                let DanhSachVe = await this.$store.dispatch(
                    "BaoCao/LayDanhSachVeDoanhNghiepTuKhaiBaoMobile",
                    {
                        NgayLoc: this.LocBaoCao.TuNgay,
                        skip: this.DanhSachVe.length,
                        take: take,
                    }
                );
                DanhSachVe.forEach((e) => {
                    e.DaChon = false;
                });
                this.DanhSachVe.push(...DanhSachVe);
                console.log("🚀 ~ DanhSachVe:", DanhSachVe)
                if (this.IsChonTatCa) {
                    this.ChonTatCa();
                }
                if (DanhSachVe.length == 0 || DanhSachVe.length < take) {
                    this.DaLayHetVe = true;
                }
            } catch (error) {
                console.log("🚀 ~ LayDanhSachVe ~ error:", error);
            } finally {
                this.$stopLoading;
            }
        },
        onValueChangedChonTatCa(e) {
            if (e.value == true) {
                this.ChonTatCa();
            } else if (e.value == false) {
                this.BoChonTatCa();
            }
        },
        ChonTatCa() {
            this.DanhSachVe.forEach((e) => {
                e.DaChon = true;
            });
        },
        BoChonTatCa() {
            this.DanhSachVe.forEach((e) => {
                e.DaChon = false;
            });
        },
    },
    created() {
        this.LayDanhSachVe();
        let self = this;
        this.emitter.on("LayDanhSachVe", () => {
            self.DanhSachVe = [];
            self.LayDanhSachVe();
        });
    },
};
</script>

<style>
.bao-cao-ban-ve .dx-item.dx-list-item {
    overflow: unset;
    margin-bottom: 12px;
}
.bao-cao-ban-ve .dx-list-group-body {
    max-height: calc(100vh - 36px - 36px - 48px - 44px - 40px);
    overflow: auto;
}
.bao-cao-ban-ve .dx-list-group-header {
    color: #fb8c00;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex-direction: row-reverse;
    padding: 8px 8px 4px;
    border: 1px solid #dadce0;
    border-radius: 4px;
}
</style>
